import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { usePlaylistStore } from '@/store/playlist/store';
import { TemplateDarkMembersPreview } from '@/components/playlist/preview/TemplateDarkMembersPreview';

export default function DarkMembersHome() {
  useLanguage();
  const { hash } = useParams<{ hash: string }>();
  const navigate = useNavigate();
  const { getPlaylistByHash } = usePlaylistStore();

  const playlist = hash ? getPlaylistByHash(hash) : null;

  if (!playlist || playlist.template !== 'dark-members') {
    return (
      <div className="min-h-screen bg-[#0E0E0E] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-white text-2xl font-bold mb-2">
            {translateInterfaceText("Área de membros não encontrada")}</h1>
          <p className="text-gray-400">
            {translateInterfaceText("Verifique se o link está correto.")}</p>
        </div>
      </div>
    );
  }

  const handleModuleClick = (moduleId: string) => {
    navigate(`/members/${hash}/module/${moduleId}`);
  };

  return (
    <TemplateDarkMembersPreview 
      settings={playlist.darkMembersSettings}
      onModuleClick={handleModuleClick}
    />
  );
}
